/**
 * Basic Sensor model.
 *
 */

import moment from "moment";

class RawModel {
  constructor(props) {
    // Load the properties
    this.id = props.id;
    this.name = props.name;
    this.installation = props.installation;
    this.owner = props.owner ? props.owner : "- - -";
    this.group = props.group;
    this.type = props.type;
    this.enabled = props.enabled;
    this.latestMeasurement = props.latestMeasurement;
    this.active = props.active;
    this.serialNumber = props.serialNumber;
    this.latitude = props.latitude.toFixed(5);
    this.longitude = props.longitude.toFixed(5);
    this.sensors = props.sensors;
    this.insects = props.insects;
    this.turned_off = false;

    this.startDate = null;
    if (props.activePeriodStart) {
      this.startDate = moment(props.activePeriodStart, "X");
    }

    this.endDate = null;
    if (props.activePeriodEnd) {
      this.endDate = moment(props.activePeriodEnd, "X");
    }
    this.meta = props.meta;

    // Derived values
    // @TODO: We should also have states for outside and inside active period

    this.status = "off";

    // How to determine if new?
    if (!this.startDate) {
      this.status = "new";
    } else if (this.enabled && this.active) {
      this.status = "on";
    } else if (this.enabled && !this.active) {
      this.status = "onNoData";
    } else if (!this.enabled && this.active) {
      this.status = "offData";
    }

    // categorise the measurement period
    var now = moment();

    this.period = "none";
    if (this.startDate && this.startDate.diff(now) > 0) {
      this.period = "future";
    } else if (this.endDate && this.endDate.diff(now) < 0) {
      this.period = "past";
    } else if (this.startDate) {
      this.period = "now";
    }

    // Measurments and depths
    this.allmeasurements = []; // moet all measurements worden
    this.measurements = {};
    this.extra_measurements = {};
    this.depths = {};

    // Error object
    this.errors = {
      name: false,
      latitude: false,
      longitude: false,
      startDate: false,
      depths: false,
      scale: {},
    };

    // Don't trigger validation directly
    this.valid = true;
  }
}
export default RawModel;
